export default __webpack_public_path__ + "static/media/jh.e0c7ba52.png";